/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_IntroInputs */

const en_contact_intro = /** @type {(inputs: Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One recent example is enough to start. We read every message ourselves and reply within one working day.`)
};

const lv_contact_intro = /** @type {(inputs: Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viens nesens piemērs ir pietiekams, lai sāktu. Katru ziņu izlasām paši un atbildam vienas darba dienas laikā.`)
};

/**
* | output |
* | --- |
* | "One recent example is enough to start. We read every message ourselves and reply within one working day." |
*
* @param {Contact_IntroInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const contact_intro = /** @type {((inputs?: Contact_IntroInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_IntroInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_contact_intro(inputs)
	return en_contact_intro(inputs)
});